export const BLOB_URL =
  process.env.REACT_APP_BLOB_URL || "https://hline.blob.core.windows.net/hlinefiles";
